import update from 'immutability-helper';
import isEmpty from 'lodash/isEmpty';
import { deepFreeze } from 'utils/deepFreeze';

import {
  INTERSTITIALS_FULFILLED,
  INTERSTITIALS_PENDING,
  INTERSTITIALS_REJECTED,
  INTERSTITIALS_UPDATED,
} from 'redux/modules/interstitials/actions/types';

const initialState = deepFreeze({
  empty: false,
  error: null,
  hash: null,
  loaded: false,
  loading: false,
  steps: [],
  valid: true, // have we been told there are no interstitials
});

const stepIsCurrent = (currentStep, { id }) => currentStep === id;
const interstitialsAreValid = (steps = []) => steps.length > 0;
const emptyOfContent = ({ result: { componentsAndProducts, locations } }) =>
  [componentsAndProducts, ...Object.values(locations ?? {})].every(isEmpty);

export default function interstitials(state = initialState, action = {}) {
  switch (action.type) {
    case INTERSTITIALS_FULFILLED: {
      const {
        result: { interstitials: { hash = null, steps: newSteps, currentStep } = {} } = {},
        isChristmas,
      } = action;

      const filteredSteps = isChristmas
        ? (newSteps || state.steps).filter(
            ({ label }) =>
              label !== 'Get set for christmas' &&
              label !== 'Stock up for christmas' &&
              label !== 'Dont forget' &&
              label !== 'Happy new year',
          )
        : newSteps;

      return {
        ...state,
        hash,
        loaded: true,
        loading: false,
        empty: emptyOfContent(action),
        steps: update(state.steps, {
          $apply: steps =>
            (filteredSteps || steps)?.map(step => ({
              ...step,
              current: step.current ? true : stepIsCurrent(currentStep, step),
              visited: step.visited ? true : stepIsCurrent(currentStep, step),
            })),
        }),
        valid: interstitialsAreValid(filteredSteps || state.steps),
      };
    }

    case INTERSTITIALS_UPDATED: {
      const { id: currentStepOld } = state.steps?.find(step => !step.visited) || {};
      return {
        ...state,
        loading: true,
        steps: update(state.steps, {
          $apply: steps =>
            steps?.map(step => ({
              ...step,
              current: stepIsCurrent(currentStepOld, step),
              visited: step.visited ? true : stepIsCurrent(currentStepOld, step),
            })),
        }),
      };
    }

    case INTERSTITIALS_PENDING:
      return {
        ...state,
        error: null,
        loading: true,
        empty: false,
      };

    case INTERSTITIALS_REJECTED:
      return {
        ...state,
        error: action.error,
        loaded: false,
        loading: false,
        empty: false,
        valid: false,
      };
    default:
      return state;
  }
}
